var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.3fc7c31cc4ce1b4e0be802279e7fe16a.svg#bp';
                    var viewUrl = 'sprites.3fc7c31cc4ce1b4e0be802279e7fe16a.svg#view-bp';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 47 56',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };